export function importPasswordResetChunk(initiatorElement: HTMLElement) {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-passwordReset' */ './PasswordReset'
  ).then(({ default: PasswordReset }) => {
    new PasswordReset(initiatorElement);
  });
}

export function importPasswordResetChunkOnClick() {
  document
    .querySelectorAll<HTMLElement>('.js-password-reset')
    .forEach((initiatorElement) => {
      if (initiatorElement.classList.contains('js-password-reset--loaded'))
        return;
      initiatorElement.classList.add('js-password-reset--loaded');

      initiatorElement.addEventListener(
        'click',
        () => importPasswordResetChunk(initiatorElement),
        {
          once: true,
        }
      );
    });
}
